module.exports = __webpack_public_path__ + "static/media/tony.97915a82.jpg";